/**
 * User/Profile endpoints (spec §10.4–§10.6).
 */
import {
  completeOnboardingResponseSchema,
  userProfileSchema,
  type CompleteOnboardingRequest,
  type CompleteOnboardingResponse,
  type UpdateProfileRequest,
  type UserProfile,
} from './apiSchemas';
import { httpClient } from './httpClient';

export function getMe(signal?: AbortSignal): Promise<UserProfile> {
  return httpClient.get('/users/me', userProfileSchema, signal);
}

export function updateProfile(body: UpdateProfileRequest): Promise<UserProfile> {
  return httpClient.patch('/users/me', { schema: userProfileSchema, body });
}

export function completeOnboarding(
  body: CompleteOnboardingRequest,
): Promise<CompleteOnboardingResponse> {
  return httpClient.patch('/users/me/onboarding', {
    schema: completeOnboardingResponseSchema,
    body,
  });
}
